import _sfc_main from "./component-library165.mjs";
import "./component-library166.mjs";
import normalizeComponent from "./component-library95.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _c("div", { ref: "imageTeaser", staticClass: "image-teaser", class: _vm.componentClass, style: _vm.componentStyles }, [_c("div", { staticClass: "image-teaser__background-container" }, [_vm._t("bgImage", function() {
    var _a;
    return [((_a = _vm.background) == null ? void 0 : _a.src) ? _c("PictureElement", { staticClass: "image-teaser__background-image", attrs: { "src": _vm.background.src, "src-sm": _vm.background.srcSm, "src-md": _vm.background.srcMd, "src-lg": _vm.background.srcLg, "lazy": _vm.lazy, "sizes": _vm.background.sizes, "image-style": _vm.background.style, "alt": _vm.background.alt } }) : _vm._e()];
  })], 2), _c("div", { ref: "container", staticClass: "image-teaser__container" }, [_vm.hasBadge ? _c("Badge", { staticClass: "image-teaser__badge", attrs: { "auto-width": "" } }, [_vm._t("badge")], 2) : _vm._e(), _vm._t("heading", function() {
    return [_vm.title ? _c("Heading", _vm._b({ staticClass: "image-teaser__title" }, "Heading", _vm.mappedHeadingProps, false), [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e()];
  }), _vm._t("copy", function() {
    return [_vm.description ? _c("Paragraph", { staticClass: "image-teaser__copy", attrs: { "no-margin": "" } }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()];
  }), _vm._t("image", function() {
    var _a;
    return [((_a = _vm.image) == null ? void 0 : _a.src) ? _c("PictureElement", { ref: "imageElement", staticClass: "image-teaser__image", style: _vm.image.style, attrs: { "src": _vm.image.src, "src-sm": _vm.image.srcSm, "src-md": _vm.image.srcMd, "src-lg": _vm.image.srcLg, "lazy": _vm.lazy, "sizes": _vm.image.sizes, "alt": _vm.image.alt } }) : _vm._e()];
  }), _vm.$slots.default ? _c("div", { staticClass: "image-teaser__default" }, [_vm._t("default")], 2) : _vm._e(), _c("div", { staticClass: "image-teaser__button" }, [_vm._t("button")], 2)], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "bc53ef74",
  null,
  null
);
const imageTeaser = __component__.exports;
export {
  imageTeaser as default
};
